module.exports = __webpack_public_path__ + "static/img/31.6f3f064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/31.png
// module id = 7SFz
// module chunks = 1